export const environment = {
    production: true,
    identityUrl: 'https://identity-v2.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://assess-v2-prod.nside.io',
    apiBaseUrl: 'https://assess-api-prod.nside.io',
    tipsApiBaseUrl: 'https://tips-v2-prod.nside.io'
};
